import { Route, Routes } from "react-router-dom";

import { Reconciliation, Reports, ReportsBalance, Revenue } from "../../pages";

export const ReportsLayout = () => {
  return (
    <Routes>
      <Route path="/" element={<Reports />} />
      <Route path="/balance" element={<ReportsBalance />} />
      <Route path="/reconciliation" element={<Reconciliation />} />
      <Route path="/revenue" element={<Revenue />} />
    </Routes>
  );
};
